/**
 *
 * Created Date: 2019-06-06, 01:30:14 (zhenliang.sun)
 * Last Modified: 2019-08-08, 18:18:02 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */
import { EventEmitter } from 'events';
import { MessageType } from '../constants/Constants';

export default class Receiver {
  constructor() {
    this.app = null;
    this.emitter = new EventEmitter();
    this.e = {
      add: this._addHandler.bind(this),
      remove: this._removeHandler.bind(this),
      removeAll: this._removeAllHandler.bind(this),
      modify: this._modifyHandler.bind(this)
    };
    this._initHandler();
  }

  get items() {
    return this.app.items;
  }

  _initHandler() {
    this.emitter.on(MessageType.Add, this.e.add);
    this.emitter.on(MessageType.Remove, this.e.remove);
    this.emitter.on(MessageType.RemoveAll, this.e.removeAll);
    this.emitter.on(MessageType.Modify, this.e.modify);
    this.emitter.on(MessageType.Undo, () => {
      this.items.undo(false);
    });
    this.emitter.on(MessageType.Redo, () => {
      this.items.redo(false);
    });
  }

  _addHandler(data) {
    let obj = JSON.parse(data);
    this.items.add(obj);
  }

  _removeHandler(data) {
    let obj = JSON.parse(data);
    this.items.remove(obj);
  }

  _removeAllHandler(data) {
    this.items.removeAll(false);
  }

  _modifyHandler(data) {
    let obj = JSON.parse(data);
    this.items.modify(obj);
  }
}
